import React, { useState, useEffect } from "react";
import HotTable from "@handsontable/react";
import "handsontable/dist/handsontable.full.css";
import "../../../index.css";
import { SexRender, SpeciesCodeRender, DateRender, WeightRender, wingRender, ringNoRenderer, ageRender, SpeciesRender, LocalityRender, moultRender, plumageRender, broodRender, billRender, tarsRender, tailRender } from "./HandOnRender";

const BlankTable = React.forwardRef((props, ref) => {
  const { onDataChange, TableData } = props;
  const [cols, setCols] = useState([]);
  // Extract headers dynamically from API response
  const headers = TableData?.updated_headers || [
    "id",
    "SpeciesCode",
    "RingNo",
    "Species",
    "Sex",
    "Age",
    "Wing",
    "Weight",
    "Date",
    "Locality",
    "Remarks",
    "Ticks",
    "Year",
    "RingSize",
    "Leg"
  ];
  const columnListBuilder = async (list) => {
    if (typeof list !== 'undefined') {
      const fixedList = {
        "id": {
          data: "id",
          type: "text",
          fixedColumnsStart: true
        },
        "Sex": {
          data: "Sex",
          type: "dropdown",
          source: ["", "Male", "Female", "Unknown"],
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            SexRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "RingSize": {
          data: "RingSize",
          type: "dropdown",
          source: ["A", "AB", "B", "C", "F", "AA", "BC", "G", "K", "L", "M", "YZ", "Z", "NA"]
        },
        "RingNo": {
          data: "RingNo",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            ringNoRenderer(instance, td, row, col, prop, value, cellProperties,
              TableData.errorList['' + row + '_' + prop])
          },
        },
        "Species": {
          data: "Species",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            SpeciesRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },

        },
        "Wing": {
          data: "Wing",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            wingRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Weight": {
          data: "Weight",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            WeightRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Date": {
          data: "Date",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            DateRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "SpeciesCode": {
          data: "SpeciesCode",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            SpeciesCodeRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Locality": {
          data: "Locality",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            LocalityRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Leg": {
          data: "Leg",
          type: "dropdown",
          source: ["", "Left Leg", "Right Leg"],
        },
        "Ringer": {
          data: "Ringer",
          type: "text",
        },
        "Age": {
          data: "Age",
          type: "dropdown",
          source: ["", "AD", "IMM", "JUV", "FG", "FW", "1Y"],
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            ageRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Moult": {
          data: "Moult",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            moultRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Plumage": {
          data: "Plumage",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            plumageRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Brood": {
          data: "Brood",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            broodRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Bill": {
          data: "Bill",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            billRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Tars": {
          data: "Tars",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            tarsRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
        "Tail": {
          data: "Tail",
          type: "text",
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            tailRender(instance, td, row, col, prop, value, cellProperties, TableData.errorList['' + row + '_' + prop])
          },
        },
      }

    

      const t = await list.map(e => {
        if (typeof fixedList[e] !== 'undefined') {
          return fixedList[e];
        }
    })     

      setCols(t);
    }

  };

  useEffect(() => {
  
          columnListBuilder(headers);
  
      }, [TableData])

  // Format API data to ensure all rows have valid keys
  const initialData = TableData?.updated_data?.map((row) => {
    let formattedRow = {};
    headers.forEach((key) => {
      formattedRow[key] = row[key] || ""; // Ensure all keys exist
    });
    return formattedRow;
  }) ||
    Array(10)
      .fill(null)
      .map(() => ({}));

  const [tableData, setTableData] = useState(initialData);

  // Create column definitions dynamically based on API keys
  const columns = headers.map((key) => ({
    data: key,
    type: typeof initialData[0]?.[key] === "number" ? "numeric" : "text",
    title: key,
  }));

  const addRow = () => {
    const newRow = {};
    headers.forEach((key) => {
      newRow[key] = "";
    });
    setTableData((prevData) => [...prevData, newRow]);
  };

  const handleTableChange = (changes, source) => {
    if (source === "edit" || source === "paste") {
      const updatedData = [...tableData];
      changes.forEach(([rowIndex, prop, oldValue, newValue]) => {
        if (oldValue !== newValue) {
          updatedData[rowIndex] = {
            ...updatedData[rowIndex],
            [prop]: newValue,
          };
        }
      });
      setTableData(updatedData);
      onDataChange(updatedData); // Send updated data to parent
    }
  };

  useEffect(() => {
    onDataChange(tableData); // Pass initial data to parent
  }, []);

  return (
    <div className="empty-table" style={{ height: "500px", overflowY: "auto" }}>
      <HotTable
        ref={ref}
        data={tableData}
        columns={columns}
        colHeaders={headers}
        filters={true}
        dropdownMenu={true}
        height="30vh"
        width="100%"
        autoWrapRow={true}
        autoWrapCol={true}
        autoColumnSize={true}
        multiColumnSorting={true}
        manualColumnFreeze={true}
        manualColumnResize={true}
        comments={true}
        licenseKey="non-commercial-and-evaluation"
        afterChange={handleTableChange}
        contextMenu={true}
      />
      {/* <button
        onClick={addRow}
        style={{
          margin: "0.5rem 2rem",
          padding: "8px 12px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          float: "right",
        }}
      >
        Add Row
      </button> */}
    </div>
  );
});

export default BlankTable;
